import { createModel, createSaga, createReducer } from '@/store/tools';
import { put, takeEvery } from 'redux-saga/effects';
import http from '@/assets/api/http';

const dataList = { dataList: [], pageNum: 1, pageSize: 20, resultTotal: 0 };
const model = {
    namespace: 'rate',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getRetaList': T('getRetaList'),
            'getRetaStatus': T('getRetaStatus'),
            'getHistoricalList': T('getHistoricalList'),
        },
        actions: {
            'getRetaList': A('getRetaList'), // 列表数据
            'getRetaStatus': A('getRetaStatus'), // 设置项下拉数据
            'getHistoricalList': A('getHistoricalList'), // 历史记录列表数据
        },
        sagas: {
            'getRetaList': S('getRetaList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.RatioSettingMisService.listRatioSetting', 'POST'),
            'getRetaStatus': S('getRetaStatus', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum', 'POST'),
            'getHistoricalList': S('getHistoricalList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.RatioSettingHistoryMisService.listRatioSettingHistoryBySettingName', 'POST'),
        },
        reducers: {
            'retaList': R('getRetaList', dataList),
            'rateStatus': R('getRetaStatus', []),
            'historicalList': R('getHistoricalList', []),
        }
    })
};
export default createModel(model);